export const EDITING_BARRA = "barrainformacao.editando_cabecalho";
export const EDIT_BARRA_COMPLETE = "barrainformacao.edita_cabecalho";
export const EDITED_BARRA_ERROR = "barrainformacao.editou_cabecalho";

export const CANCELA_ADESAO = "barrainformacao.cancela_adesao";
export const CANCELOU_ADESAO = "barrainformacao.cancelou_adesao";
export const CANCELA_ADESAO_ERRO = "barrainformacao.cancela_adesao_erro";

export const INIT_FETCH = "barrainformacao.iniciou_fetch";
